import { useEffect } from 'react';
import { useSettingsStore, applyTheme } from '../store/settings';

export function useThemeInit() {
  const theme = useSettingsStore((state) => state.theme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);
}
